import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import ReactDOM from "react-dom";
import async from "./components/Async";
const App = async(() => import("./App"));

ReactDOM.render(<App />, document.getElementById("root"));
